import { FC } from "react";
import { AccordionCollapseProvider } from "./AccordionsCollapseContext";

export interface AccordionContainerProps {
  children?: React.ReactNode;
  /**
   * Optional classname to add to the div
   * */
  className?: string;
}

/**
 * A simple container for the actual collapsing accordions (Accordion).
 * This container is optional, but enables the "close siblings when an accordion is opened" functionality.
 */
export const AccordionContainer: FC<AccordionContainerProps> = (props: AccordionContainerProps) => {
  return (
    <AccordionCollapseProvider>
      <div className={`qes-accordion-container ${props.className || ""}`}>
        {props.children}
      </div>
    </AccordionCollapseProvider>
  );
}
